module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/41ubUzwYAoqEOIYC0oueE6-3b9e6e3b940563948b6f4633a09ce98b.jpg";